import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
import { responsiveStyles } from '../../core/utils/responsiveStyles';

const IconButton = ({ onClick, text, ...rest }) => {
  return (
    <ActionTextWrapper {...rest} onClick={onClick} enableInteraction={true}>
      {text}
    </ActionTextWrapper>
  );
};

IconButton.propTypes = {
  onClick: PropTypes.func,
  text: PropTypes.string
};

export const ActionTextWrapper = withTheme(
  styled.div`
    ${({ coreTheme }) => css`
      color: ${coreTheme.cl_sec_d1};
      line-height: 21px;
      font-family: ${coreTheme?.iconButton?.fontFamily ??
        coreTheme.ff_sec_bold};
      cursor: pointer;
      ${coreTheme?.iconButton?.fontSize
        ? {
            ...responsiveStyles(
              {
                fontSize: coreTheme?.iconButton?.fontSize
              },
              coreTheme
            )
          }
        : { fontSize: coreTheme.fs_xl }};
      ${coreTheme?.iconButton?.fontWeight && {
        fontWeight: coreTheme?.iconButton?.fontWeight
      }};
    `};
  `
);

export default withTheme(IconButton);
